<template>
	<v-tooltip bottom >
		<template v-slot:activator="{ on }">
			<v-btn small icon color="gray" v-on="on" @click="onClick">
				<v-icon dark>{{icon}}</v-icon>
			</v-btn>
		</template>
		<span>{{tooltipText}}</span>
	</v-tooltip>
</template>

<script>
	export default {
		name: "remove-btn",
		props: {
			data: {required: false, default: null},
			options: {
				type: Object, default: () => {
					return {};
				}
			},
			tooltipText: {default: "מחיקה"},
			icon: {default: "delete", type: String}
		},
		components: {},
		data() {
			return {};
		},
		computed: {},
		methods: {
			onClick() {
				this.$emit("click", this.data);
				this.$notfication.warning(undefined, undefined, this.options).then((event) => {
					if (event.value) {
						this.$emit("remove", event.value);
					}
				});
			}
		}
	};
</script>

<style scoped>
	button {
		/*float: left;*/
	}

	.red-color {
		color: #cccccc !important;
	}
</style>
